module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Jakob_480x480.52697d49.mp4";